import Table from "react-bootstrap/Table";
import Button from 'react-bootstrap/Button';
import "./index.scss";
import Download_icon from "assets/images/download_icon.svg";
import Comment_icon from "assets/images/comment.svg";
import Row from 'react-bootstrap/Row';
import Option from "../../assets/images/option.svg";
import { useNavigate } from "react-router-dom";
import Image from "lib/Image";
import PopoverComponent from "lib/Popover";
import FilterComponent from "lib/Filter";
import { Form } from "react-bootstrap";
import { PaginationComponent } from "lib";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsUserClicked } from "redux/usersReducer";
import { deleteWorkflowInfoById } from "api/formDisplay";
import DynamicForm from "components/DynamicForm";
import { BASE_URL } from "constants/routes";
import NoDataFoundPic from "assets/images/NoDataFoundPic.png";
import { handleEmailNotification } from "helper/callbacks";
import { sendreminderAboutStatus } from "api/dashboardDetail";
import { encryptURLParams } from "api/UrlEncryption";
import { getProfileNameExceptMrs, randomProfileColors } from "helper/index";
import copyclipboard from "assets/images/copyclipboard.png";
import Toast from "components/ToastComponent";
import userInfo from "redux/userInfo";
import  { clearVerificationWorkflows, dashboardReducer, setFilterCheckboxList, setSelectedTableSortOptions, setVerificationWorkflows } from "redux/dashboardReducer";
import { dashboardConfig } from "assets/dashboardConfig";
import { setDynamicConfigID } from "redux/dashboardReducer";
import { createLinkExpiry } from "api/configuration";
import { encryptUrl } from "api/UrlEncryption";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { formatData } from "helper/common";
import { setSelectedData } from "redux/formDisplay";
import Pagination from "react-bootstrap/Pagination";
import { setRowPerPage, setRowsChange, setNumberOfRecords } from "redux/dashboardReducer";
import { Dropdown } from "react-bootstrap";
import Status from "lib/Status/Status";
import {fetchReportingManagerInfo, getUserNamesByIds} from 'api/user'


/**
 ** This function removes all the un-wanted HTML tags and 
 ** slices the comment up to 45 characters
 */
const getFormattedComment = (commentString) => {
  try {
    if (commentString === null || commentString === "") 
      return "";
    else {
      const trimmedString = commentString.replace(/<[^>]*>/g, "");
      return trimmedString.length > 45 ? trimmedString.slice(0,45) + "..." : trimmedString;
    }
  } catch (err) {
    console.log(err);
  }
}


const dispatchedApplicationRefIds = new Set();

const TableBody = ({
  ele,
  item,
  handleRoute,
  handleOptionsClick,
  getPopoverOfItems,
  selectedData,
  setCopiedToClipBoardSuccessFully,
  copiedToClipBoardSuccessFully,
  dashboardConfig,
  userDetails,
  toggleUserSelect,
  selectAll
}) => {

  
  
  const [profileIcon, setProfileIcon] = useState('');
  const [groupProfileIcon, setGroupProfileIcon] = useState('');
  const dispatch = useDispatch();
  const [filtersCount, setFiltersCount] = useState(0)
  const userHierarchy = useSelector((state)=>state.dashboardReducer?.dashboardConfig?.user_hierarchy)



  const getProfilePhoto = (image) => {
    if (image) {
      const imageUrl = `${BASE_URL}/workflow/viewUploadedDocument/${
        item?.primary_applicant_id
      }/${"applicant_photo"}/${image?.encrypted_filename}`;
      return imageUrl;
    } else {
      return Download_icon;
    }
  };
  const show_ref_id = useSelector((state)=>state.dashboardReducer.dashboardConfig?.show_ref_id)
  

  const handleCopyToClipboard = async (e) => {
    setCopiedToClipBoardSuccessFully(false);
    e.stopPropagation();

    try {
      await navigator.clipboard.writeText(item?.application_ref_id);
      setCopiedToClipBoardSuccessFully(true);
    } catch (err) {
      console.error("Failed to copy text: ", err);
      setCopiedToClipBoardSuccessFully(false);
    }
  };

 useEffect(() => {
    const refId = item?.application_ref_id;

    // Only dispatch if we haven't already for this application_ref_id
    if (userHierarchy && refId && !dispatchedApplicationRefIds.has(refId)) {
      dispatchedApplicationRefIds.add(refId); // Mark as fetched
      dispatch(getUserNamesByIds({ application_ref_id: refId }));
    }
  }, [item?.application_ref_id, userHierarchy]);
      
  useEffect(()=>{
    setProfileIcon(getProfileNameExceptMrs(
      item?.full_name?.[0]?.full_name,
      item?.profile_color_code
    ))
    setGroupProfileIcon(getProfileNameExceptMrs())
  },[item?.profile_color_code,item?.full_name])

  const checkCheckboxStatus = (userObj) => {
      const eachCheck = userDetails.some((user) => user.checked)
      dispatch(setSelectedData({key: 'verifyBtn', value: eachCheck}))

      if(selectAll) {
        return userDetails.every((user) => user.checked)
      }
      return userObj?.checked;
  }

 

  useEffect(() => {
      checkCheckboxStatus()
  }, [userDetails])
  if (ele?.id === "full_name" || ele?.id === "application_ref_id") {
    const is_photo_required = ele?.show_profile_photo;
    const userObj = userDetails.find(index => index?.workflow_id === item?.workflow_id)
    return (
      <div className="ms-0 verify-span-checkbox" key={userObj?.workflow_id}>
        
        {dashboardConfig?.header_structure?.bulk_bank_verification 
            && 
            <input
            type="checkbox"
            checked={checkCheckboxStatus(userObj)}
            onChange={(e) => toggleUserSelect({userId: userObj?.workflow_id, event: e})}
          />
        }
      <div 
        className="primary_usercard cursor-pointer bg-white"
        onClick={() => handleRoute(item?.workflow_id)}
      >
        
        <div className="user_container">
          <div className="profile">
            {ele?.id === "full_name" && item.profile_photo &&is_photo_required&& (
              <Image
                imageSrc={getProfilePhoto(item.profile_photo)}
                className="user_profile"
              />
            )}
            {(ele?.id === "full_name" && item?.full_name?.length === 1 &&(!item.profile_photo||!is_photo_required)) && (
              <div className="profile_image">
                {profileIcon}
              </div>
            )}
            {(ele?.id === "full_name" && item?.full_name?.length > 1 &&(!item.profile_photo||!is_photo_required))&& (
               <div className="profile_image">
               {groupProfileIcon}
             </div>
            )}
            <div>
              <p className="user_name fs-14px d-flex">
                {Array.isArray(item?.[ele?.id])
                  ? getPopoverOfItems({
                      item: item?.[ele?.id],
                      field_id: ele?.id,
                      route_id: item?.["workflow_id"],
                      delay: 500,
                    }
                  )
                  : item?.[ele?.id]}
              <span className="mt-1">
                  {(ele?.id === "application_ref_id") ?  (
                <p className="user_id fs-11px">
                  {/* {item?.application_ref_id} */}
                  <span onClick={handleCopyToClipboard} id="copy_clipboard">
                    <Image
                      imageSrc={copyclipboard}
                      className="copy_to_clipboard"
                    />
                  </span>
                </p>
              ) : null}
                  </span>
              </p>
              {/* show_ref_id || show_ref_id == undefined */}
              
            </div>
          </div>
        </div>
      </div>
      </div>
    );
  } else if (ele?.id === "comments") {
    return (
      <div className="usercard_data cursor-pointer">
        {Array.isArray(item?.[ele?.id]) && item?.[ele?.id]?.length > 0 ? (
          getPopoverOfItems({
            item: item?.[ele?.id],
            comment_count: item?.comment_count,
            field_id: "body",
            route_id: item?.["workflow_id"],
            delay: 2000,
          })
        ) : (
          <Image imageSrc={Comment_icon} className="comments" />
        )}
      </div>
    );
  } else if (ele?.id === "status") {
    // const getBgColor =
    //   item?.[ele?.id]?.toLowerCase() === "awaiting approval"
    //     ? "bg-purple"
    //     : "bg-blue";
    // const color =
    //   item?.[ele?.id]?.toLowerCase() === "in draft" ? "bg-orange" : getBgColor;
    // return item?.[ele?.id]?.length > 25 ? (
    //     <OverlayTrigger
    //         placement="bottom"
    //         delay={{hide:10}}
    //         overlay={<Tooltip id="tooltip-disabled">{item?.[ele?.id]}</Tooltip>}
    //         className="overlay"
    //     >
    //         <span
    //             className={`d-inline-block status-label text-truncate p-2 mt-2 w-175px ${color}`}
    //         >
    //             {item?.[ele?.id]}
    //         </span>
    //     </OverlayTrigger>
    // ) : (
    //     <span
    //         className={`d-inline-block status-label text-truncate p-2 mt-2 ${color}`}
    //     >
    //         {item?.[ele?.id]}
    //     </span>
    // );
   
   return <Status status={item?.[ele?.id]}/>
  }else if (ele?.id === "request_change_status"){
    if(item?.[ele?.id] != null){
      return <Status requestChange={item?.[ele?.id]}/>
    }else{
      return "-";
    }
  }
   else if(ele?.id === "bank_status") {
    const getBgColor =
     item?.[ele?.id]?.toLowerCase() === "verified"
        ? "bg-verify"
        : item?.[ele?.id]?.toLowerCase() === "failed" ? "bg-red" : "";
    const color =
      item?.[ele?.id]?.toLowerCase() === "verified" ? "bg-verify" : getBgColor;
      return ( <span
            className={`d-inline-block status-label text-truncate p-2 mt-2 ${color}`}
        >
            {`${item?.[ele?.id] ? item?.[ele?.id] : "-"}`}
        </span>
   )
  }
  else if (ele?.id === "icon") {    
    const { show, type, trigger_when, list_items } = ele;
    return (
      <>
        {type && eval(show) ? (
          <DynamicForm
            formFields={ele}
            selectedData={{ ...selectedData, ...item }}
            triggerItem={
            
           
                <a className="cursor-pointer popover-btn">
                  {/* <Image  imageSrc={Option} /> */}               
                <svg className="rotateZ-90 ms-1" xmlns="http://www.w3.org/2000/svg" width="2.515" height="13.71" viewBox="0 0 2.515 13.71">
                  <path id="Combined_Shape" data-name="Combined Shape" d="M.015,12.46a1.25,1.25,0,1,1,1.25,1.25A1.25,1.25,0,0,1,.015,12.46ZM0,7.072a1.25,1.25,0,1,1,1.25,1.25A1.25,1.25,0,0,1,0,7.072ZM0,1.25A1.25,1.25,0,1,1,1.25,2.5,1.25,1.25,0,0,1,0,1.25Z" fill="#4d4d4d"/>
                </svg>
                </a>
               
            
            }
            handleItemClick={(action, opt) =>
              handleOptionsClick({ action, ...opt }, item)
            }
          />
        ) : (
          ""
        )}
      </>
    );
  } else if (ele.type) {
    const { show, type } = ele;
    return (
      <>
      
        {type && eval(show) && (
          <DynamicForm
            formFields={ele}
            selectedData={{ ...selectedData, ...item }}
            handleItemClick={(action, opt) =>
              handleOptionsClick(
                { action, ...opt },
                { ...item, ...selectedData},
                {ele}
                
              )
            }
          />
        )}
      </>
    );
  }
  else if(ele?.id === "email"){
    return item?.[ele?.id]?.length > 25 ? (
      <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="tooltip-disabled">{item?.[ele?.id]}</Tooltip>}
          className="overlay"
      >
          <span
              className={`d-inline-block mt-2 text-truncate w-150px`}
          >
              {item?.[ele?.id]} 
          </span>
      </OverlayTrigger>
  ) : (
      <span
          className={``}
      >
          {item?.[ele?.id]}
      </span>
  );
  }
  else if(ele?.id === "service_type"){
    return item?.[ele?.id]?.length > 20 ? (
      <OverlayTrigger
           placement="bottom"
          delay={{hide:1}}
          overlay={<Tooltip id="tooltip-disabled">{item?.[ele?.id]}</Tooltip>}
          className="overlay"
      >
          <span
              className={`d-inline-block mt-2 text-truncate w-150px`}
          >
             {item?.[ele?.id]} 
          </span>
      </OverlayTrigger>
  ) : (
      <span
          className={``}
      >
          {item?.[ele?.id]}
      </span>
  );
  }
  else if(ele?.id === "company"){
    return item?.[ele?.id]?.length > 20 ? (
      <OverlayTrigger
           placement="bottom"
          delay={{hide:1}}
          overlay={<Tooltip id="tooltip-disabled">{item?.[ele?.id]}</Tooltip>}
          className="overlay"
      >
          <span
              className={`d-inline-block mt-2 text-truncate w-150px`}
          >
              {item?.[ele?.id]}
          </span>
      </OverlayTrigger>
  ) : (
      <span
          className={``}
      >
          {item?.[ele?.id] || "-"}
      </span>
  );
  }
  else if (ele?.id === 'view_button') {

    // const { show, type, trigger_when, list_items } = ele;
    return (
          <DynamicForm
            formFields={ele}
            selectedData={{ ...selectedData, ...item }}
            triggerItem={
              <>
                <button className="btn text-dark bg-theme-grey-1 px-3 me-3 fs-12px d-none d-lg-block d-md-block">
                  View
                </button>
              </>
            }
            handleItemClick={(action, opt) =>
              handleOptionsClick({ action, ...opt }, item)
            }
          />
    );
  }
  else {
    const rawData = item?.[ele?.id];
    if(ele?.format_details && rawData) {
      const formattedData = formatData(rawData, ele?.format_details);
      return <>{formattedData || "-"}</>;
    } else {
      return <>{rawData || "-"}</>;
    }
  }
};

const Filter = ({
  ele,
  getSortList,
  getFilerCheckList,
  name,
  selectedFilterCheckboxList
}) => {
  const [filtersApplied,setFiltersApplied] = useState(false)
  const [showDropDown, setShowDropDown] = useState(null);
  const selectedTableSortOptions = useSelector(state => state.dashboardReducer.selectedTableSortOptions);

  const handleDropdownChange = (value) => {
    if (showDropDown === null)
      setShowDropDown(() => value);
    else
      setShowDropDown(() => null);
  };

  useEffect(()=>{
    setFiltersApplied(selectedFilterCheckboxList[name.toLowerCase()] && Object.values(selectedFilterCheckboxList[name.toLowerCase()]).some(val => val === true))
  },[selectedFilterCheckboxList,name])

  return (
    <FilterComponent
      name={ele}
      placement={ele?.filter_type === "sort" ? '':'bottom-start'}
      trigger={
        <button className={`btn p-0 ms-2 d-flex align-items-center justify-content-center p-1 bg-grey-hover-1 bg-active-grey border-0 rounded-0 ${ filtersApplied ? 'bg-theme-grey-3 py-0':''}`}>
          { ele?.icon == "icon-name" ?
          (Object?.keys(selectedTableSortOptions)?.length 
              ? Object?.keys(selectedTableSortOptions).includes(ele?.id) 
              ? Object?.keys(selectedTableSortOptions[ele?.id]).includes("+1") 
              ? (<i className="fa-solid fa-arrow-down-a-z pl-4"></i>) 
              : (<i className="fa-solid fa-arrow-down-z-a pl-4"></i>)
              : null 
              : null
            ) :

             ( Object?.keys(selectedTableSortOptions)?.length 
              ? Object?.keys(selectedTableSortOptions).includes(ele?.id) 
              ? Object?.keys(selectedTableSortOptions[ele?.id]).includes("-1") 
              ?<svg xmlns="http://www.w3.org/2000/svg" width="16.96" height="14.733" viewBox="0 0 16.96 14.733">
              <g id="Group_49448" data-name="Group 49448" transform="translate(-1292.87 -419.171)">
                <g id="Group_49447" data-name="Group 49447" transform="translate(1300.499 422.584)">
                  <path id="Path_55212" data-name="Path 55212" d="M16887.592-20946.475h3" transform="translate(-16890.236 20947.561)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2"/>
                  <path id="Path_55213" data-name="Path 55213" d="M16887.588-20946.475h5" transform="translate(-16890.234 20950.561)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.8"/>
                  <path id="Path_55214" data-name="Path 55214" d="M16887.588-20946.475h7" transform="translate(-16890.234 20953.561)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.7"/>
                  <path id="Path_55215" data-name="Path 55215" d="M16887.59-20946.475h10" transform="translate(-16890.236 20956.561)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.6"/>
                  <g id="Group_49449" data-name="Group 49449" transform="translate(-7.629)">
                    <path id="Path_55061" data-name="Path 55061" d="M17.585,12.573l-1.258,1.258a.608.608,0,0,1-.88,0l-1.258-1.258a.623.623,0,0,1,.88-.88l.189.189V3.329a.629.629,0,0,1,1.258,0v8.553l.189-.189a.623.623,0,0,1,.88.88Z" transform="translate(-14 -2.7)"/>
                  </g>
                </g>
                <text id="N" transform="translate(1309.83 427.171)" font-size="8" font-family="Outfit" font-weight="700"><tspan x="-5" y="0">N</tspan></text>
              </g>
            </svg>
              : <svg xmlns="http://www.w3.org/2000/svg" width="16.96" height="13.587" viewBox="0 0 16.96 13.587">
              <g id="Group_49451" data-name="Group 49451" transform="translate(-1292.87 -422.584)">
                <g id="Group_49447" data-name="Group 49447" transform="translate(1300.499 422.584)">
                  <g id="Group_49452" data-name="Group 49452" transform="translate(-2.646 1.086)">
                    <path id="Path_55212" data-name="Path 55212" d="M16887.592-20946.475h3" transform="translate(-16887.588 20955.475)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.6"/>
                    <path id="Path_55213" data-name="Path 55213" d="M16887.588-20946.475h5" transform="translate(-16887.588 20952.475)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.7"/>
                    <path id="Path_55214" data-name="Path 55214" d="M16887.588-20946.475h7" transform="translate(-16887.588 20949.475)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.8"/>
                    <path id="Path_55215" data-name="Path 55215" d="M16887.59-20946.475h10" transform="translate(-16887.588 20946.475)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2"/>
                  </g>
                  <g id="Group_49449" data-name="Group 49449" transform="translate(-7.629)">
                    <path id="Path_55061" data-name="Path 55061" d="M17.585,4.146,16.327,2.889a.608.608,0,0,0-.88,0L14.189,4.146a.623.623,0,0,0,.88.88l.189-.189v8.553a.629.629,0,0,0,1.258,0V4.838l.189.189a.623.623,0,0,0,.88-.88Z" transform="translate(-14 -2.7)"/>
                  </g>
                </g>
                <text id="_0" data-name="0" transform="translate(1309.83 434.171)" font-size="8" font-family="Outfit" font-weight="700"><tspan x="-5" y="0">0</tspan></text>
              </g>
            </svg>            
              : null 
              : null
          )
        }
            {
              ele?.filter_type === "sort" ? (<i className={`fas fa-angle-${showDropDown ? "up" : "down"}`}></i>) : ( <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-funnel" viewBox="0 0 16 16">
              <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z"/>
              </svg>)
            }
            {
              selectedFilterCheckboxList[name] && (
                <p className="fs-13px mb-0 mt-1 ms-1">
              {selectedFilterCheckboxList[name] && (Object.values(selectedFilterCheckboxList[name])?.filter(val => val === true)?.length ? 
                Object.values(selectedFilterCheckboxList[name])?.filter(val => val === true)?.length : null
              )}
            </p>
              )
            }
        </button>
      }
      handleToggle={handleDropdownChange}
      children={
        <>
          {
            ele?.filter_type === "sort"
            ? getSortList(ele.id, ele.datatype, ele?.filter_type)
            : getFilerCheckList(ele.id, ele.datatype, ele?.filter_type,name)
          }
        </>
      }
      fullBodyPresent={true}
    />
  );
}

const FilterOptions = ({
  current_filter,
  id,
  name,
  handleFilterCheckBoxList,
  handleBulkFilterCheckBoxList,
  dataType,
  filterType,
  handleClearSort,
  handleClearFilter,
  handleApplyFilter,
  selectedFilterCheckboxList
}) => {

  const ref = useRef(null);
  const [filterList, setFilterList] = useState([...current_filter]);
  
  const handleSearchFilter = (e) => {
    let timer;
    let newList;
    clearTimeout(timer);
    timer = setTimeout(() => {
      if(e.target.value.length) {
        newList = filterList.filter((item) => item?.lable?.toLowerCase()?.startsWith(e.target.value?.toLowerCase()));
      } else {
        newList = [...current_filter];
      }
      setFilterList(newList);
    }, 500);
  }

  return (
    <div className="position-relative d-inline-block">
  <div
    className=".option_list bg-white shadow-3 pt-3 rounded-2"
    style={{
      position: 'absolute',
      zIndex: 1050,
      minWidth: '200px',
      maxWidth: '250px',
      width: 'fit-content',
      maxHeight: '350px',
      overflowY: 'auto'
    }}
  >
      <p className="fs-13px mb-0 text- text-uppercase px-3 pb-2">{name.replace(/_/g, ' ')}</p>
      {
        current_filter.length > 8 ? (
          <div className="mx-3 border rounded-1 d-flex align-items-center px-1 mb-2">
            <span className="ms-1 me-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 18.006 18.006">
                <g id="Layer_2" data-name="Layer 2" transform="translate(-3 -3)" opacity="0.268">
                  <path id="search" d="M20.71,19.29l-3.4-3.39A7.92,7.92,0,0,0,19,11a8,8,0,1,0-8,8,7.92,7.92,0,0,0,4.9-1.69l3.39,3.4a1,1,0,1,0,1.42-1.42ZM5,11a6,6,0,1,1,6,6,6,6,0,0,1-6-6Z"/>
                </g>
              </svg>
            </span>
            <input className="border-0 outline-0 fs-13px mt-1 w-100 py-1" placeholder="Search" type="text" onChange={(e) => handleSearchFilter(e)}/>
          </div>
        ) : (<></>)
      }
      <div className="overflow-y-auto thin-scrollbar max-h-200px me-2" ref={ref}>
      {filterList?.map((item, i) => (
        <button
          key={i}
          onClick={() => {
            if (item?.value === "selectAll") {
              const otherOptions = filterList.filter(opt => opt.value !== "selectAll");
              const isAllSelected = otherOptions.every(
                opt => selectedFilterCheckboxList[id]?.[opt.id]
              );

              const otherIds = otherOptions.map(opt => opt.id);
              handleBulkFilterCheckBoxList(otherIds, id, dataType, !isAllSelected);
            } else {
              handleFilterCheckBoxList(item?.id, id, dataType);
            }
          }}

          disabled={
            dataType === "date" &&
            selectedFilterCheckboxList[id]?.hasOwnProperty(
              selectedFilterCheckboxList[id]?.[item?.id]
            )
          }
          className="btn px-0 border-0 bg-white d-flex align-items-center w-100 py-2 px-3"
        >
          <Form.Check
            key={i}
            type={"checkbox"}
            id={item?.id}
            className=""
            bsPrefix="mt-0"
            disabled={
              dataType === "date" &&
              selectedFilterCheckboxList[id]?.hasOwnProperty(
                selectedFilterCheckboxList[id]?.[item?.id]
              )
            }
            checked={
              item?.value === "selectAll"
                ? filterList
                  .filter(opt => opt.value !== "selectAll")
                  .every(opt => selectedFilterCheckboxList[id]?.[opt.id])
                : selectedFilterCheckboxList[id]?.[item?.id] || false
            }

          />
          { item?.lable.length < 25 ?
            (
              <label className="cursor-pointer pe-2 fs-14px mt-1 ms-3">
            {item?.lable||item.placeholder}
          </label>
            ):(
              <OverlayTrigger
              placement="bottom"
              delay={{hide:10}}
              overlay={<Tooltip id="tooltip-disabled">{item?.lable}</Tooltip>}
              className="overlay"
              container={ref}
          >
              <label className="cursor-pointer pe-2 fs-14px mt-1 ms-3 text-truncate">
            {item?.lable || item?.placeholder}
          </label>
          </OverlayTrigger>
            )
          }
         
        </button>
      ))}
      </div>
      <div className="position-sticky bottom-0 bg-white border-top mb-2 rounded-bottom-2">
        {
          <button
            className="btn bg-white rounded-0 w-50  bg-hover-grey bg-active-grey fs-14px text-start px-3 rounded-bottom-2 border-0"
            onClick={() => {
              if (filterType === "sort") handleClearSort();
              else {
                handleClearFilter(id);
              }
            }}
          >
            <label className="fs-13px cursor-pointer text-label text-secondary">
              Clear filter
            </label>
          </button>
        }
               {
          <button
            className="btn bg-white rounded-0 w-50  bg-hover-grey bg-active-grey fs-14px end px-3 rounded-bottom-2 border-0"
            onClick={() => {
              handleApplyFilter()
            }}
          >
            <label className="fs-13px cursor-pointer text-label text-primary-theme">
              Apply
            </label>
          </button>
        }
      </div>
    </div>
    </div>
  );
}

function TableComponent(props) {
  const {
    fields,
    checkboxFields,
    checkboxList,
    selectedFilterCheckboxList,
    selectedTableSortOptions,
    handleSortOptionChanges,
    dateFilterCheckboxList,
    setCheckboxList,
    // setFilterCheckboxList,
    setDateFilterCheckboxList,
    handleCheckboxClear,
    handleApplyFilter,
    handleApplySort,
    handleClearFilter,
    handleClearSort,
    tableListingData,
    filterDropdownList,
    clearAllFilter,
    pagination,
    showClearFilter,
    handlePageClick,
    currentUserRole,
    updateWorkflow,
    dashboardConfig,
    verificationListingData,
    clearAllSortArray
  } = props;
  const total_count = useSelector((state) => state.dashboardReducer.tableCount);
  const numberOfRecords = useSelector((state) => state.dashboardReducer.numberOfRecords);
  const [show, setShow] = useState(false);
  // const [showPopover, setShowPopover] = useState({ _of: "" });
  const userDetails = [...tableListingData];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [copiedToClipBoardSuccessFully, setCopiedToClipBoardSuccessFully] = useState(false);
  let newUserDetails = [{...verificationListingData}];
  const [users, setUsers] = useState(newUserDetails);
  const [selectAll, setSelectAll] = useState(false);
  const { current_module, workflow_modules, internalPocUsers,all_users } = useSelector(
    (state) => state?.dashboardReducer
  );
  const organisationIdOfUser = useSelector(
    (state) =>
      state?.loggedInUserInfo?.userAuthInfo?.profileInfo?.organisationId
  );
  const organisationInfo = useSelector((state) => state?.loggedInUserInfo?.userAuthInfo?.organisationInfo)
  const loggedInUserInfo = useSelector((state) => state.loggedInUserInfo?.userAuthInfo);
  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  const [sendReminderToast, setSendReminderToast] = useState({
    status: false,
    type: "",
    message: ""
  });
  const tablelistingdata = useSelector(
    (state) => state?.dashboardReducer?.tableListingData
  );
  const total_records = tablelistingdata?.length || 10;
  
  const handleRoute = useCallback(
    async (id) => {
      let module_id =
        current_module?.detail_view_module_id ||
        workflow_modules?.low_code_detail_view;
      if (id) {
        const { id: _id, module_id: moduleId } = await encryptURLParams({
          id,
          module_id,
        });
        _id && moduleId && navigate(`/dashboard-detail/${_id}/${moduleId}`);
      }
    },
    [current_module]
  );

  const addColumnIcon = `<svg id="Component_55_2" data-name="Component 55 – 2" xmlns="http://www.w3.org/2000/svg" width="29.924" height="29.924" viewBox="0 0 29.924 29.924">
  <circle id="Ellipse_2118" data-name="Ellipse 2118" cx="14.962" cy="14.962" r="14.962" fill="rgba(var(--primary-color),0.1)"/>
  <path id="Combined_Shape" data-name="Combined Shape" d="M7.565,5.674h5.674V7.565H7.565v5.674H5.674V7.565H0V5.674H5.674V0H7.565Z" transform="translate(8.342 8.343)" fill="rgba(var(--primary-color),1)"/>
</svg>`

  const handleRedirect = (workflow_id) => {
    // navigate(`/dashboard/:${id}`)
    dispatch(setIsUserClicked(true));
    // navigate(applicantLink)
    navigate(
      "/formSubmission/639c3f61dfd2b50ab6419158/639c3f61dfd2b50ab6419156"
    );
  };
  const handleOptionsClick = async(
    { action, ...option },
    { workflow_id, ...workflow  },
    {ele} = {}
    ) => {
    if(workflow?.dynamic_config_id){
      dispatch(setDynamicConfigID(workflow?.dynamic_config_id))
    }
    if (action === "delete_workflow") {
      dispatch(deleteWorkflowInfoById(workflow_id));
    } else if (action === "edit_workflow") {
      let redirectURL = "";
      if (
        organisationInfo?.setting?.link_expiry_duration_in_hours
      ) {
        const linkExpiryObjectID = await dispatch(
          createLinkExpiry({
            organisation_id: organisationIdOfUser,
            type: "Invite Customer",
            hours: organisationInfo?.setting?.link_expiry_duration_in_hours,
            // has_link_expiry:organisationInfo?.has_link_expiry 
          })
        ).unwrap();
        if (linkExpiryObjectID) {
          if (workflow?.link?.includes("token=")) {
            redirectURL = workflow?.link.replace(
              /token=[^&]+/,
              linkExpiryObjectID?.data
            );
          } else {
            const separator = workflow?.link?.includes("?") ? "&" : "?";
            redirectURL = `${workflow?.link}${separator}${linkExpiryObjectID?.data}`;
          }
        }
        redirectURL && window.open(`${redirectURL}`, "_blank");
      } else {
        // for allowing the link to open in new route always
        redirectURL = `${workflow?.link}?userIntiated=true`
        redirectURL && window.open(`${redirectURL}`, "_blank");
      }
    }  else if (action === "assign_poc") {
      if(ele?.fetch_reporting_manager){
       let users = option?.value
       const paramObj = {
         users : [users],
         workflowId: workflow_id,
         fetchReportingManager: ele?.fetch_reporting_manager,
       };
       let res = await fetchReportingManagerInfo(paramObj);
       if(res?.data?.show_application_to){
       updateWorkflow({
        userId: workflow_id,
        workFlowId : workflow_id,
        "source_data.internal_poc_name": option?.label,
        "source_data.internal_poc_user_id": option?.value,
        "source_data.internal_poc_email_id": option?.email,
        "source_data.internal_poc_mobile_number": option?.mobile_number,
        "show_application_to": res?.data?.show_application_to?.length ? res?.data?.show_application_to : []
      });
    }
     }else{
      updateWorkflow({
        userId: workflow_id,
        workFlowId : workflow_id,
        "source_data.internal_poc_name": option?.label,
        "source_data.internal_poc_user_id": option?.value,
        "source_data.internal_poc_email_id": option?.email,
        "source_data.internal_poc_mobile_number": option?.mobile_number,
      });
    }
      let params = {
        organisation_id: organisationIdOfUser,
        to: option?.email,
        trigger: "assignInternalPoc",
        recipientName: option?.label,
        userName: workflow?.full_name[0]?.full_name,
        link: `dashboard-listing`,
      };
      handleEmailNotification(params);
    } else if (action === "send_reminder") {
      let redirectURL = "";
      if (
        organisationInfo?.setting?.link_expiry_duration_in_hours 
      ) {
        const linkExpiryObjectID = await dispatch(
          createLinkExpiry({
            organisation_id: organisationIdOfUser,
            type: "Invite Customer",
            hours: organisationInfo?.setting?.link_expiry_duration_in_hours,
          })
        ).unwrap();
        if (linkExpiryObjectID) {
          if (workflow?.link?.includes("token=")) {
            redirectURL = workflow?.link.replace(
              /token=[^&]+/,
              linkExpiryObjectID?.data
            );
          } else {
            const separator = workflow?.link?.includes("?") ? "&" : "?";
            redirectURL = `${workflow?.link}${separator}${linkExpiryObjectID?.data}`;
          }
        }
      }

      const body = {
        is_primary: true,
        userName: workflow?.full_name[0].full_name,
        email_id: workflow?.email,
        org_id: organisationIdOfUser,
        status: workflow?.status,
        trigger: option?.trigger ? option?.trigger : "send_reminder",
        message: eval(option.message),
        link: redirectURL ? redirectURL : workflow?.link,
        application_ref_id:workflow?.application_ref_id
      };
      let resp = await dispatch(sendreminderAboutStatus(body)).unwrap();
      if (resp?.status == "success") {
        setSendReminderToast({
          status: true,
          type: "success",
          message: resp?.message
        })
      } else if(resp?.status == "failed"){
        setSendReminderToast({
          status: true,
          type: "error",
          message: resp?.message
        })
      }
      setTimeout(() => {
        setSendReminderToast({
          status: false,
          type: "failed",
          message: "Unable to send reminder"
        })
      }, 3000);

    } else if (action == "view_application") {
      handleRoute(workflow_id);
    } else if (action == "edit_dynamic_workflow") {
      const splitLink = workflow?.link?.split("/");
      const primaryWorkflowId = await encryptUrl(splitLink[5]);
      const userId = await encryptUrl(splitLink[6]);
      const subWfId = await encryptUrl(splitLink[7]);
      const user_id = await encryptUrl(loggedUserId ? loggedUserId : userId);
      window.open(`dynamicworkflow/${primaryWorkflowId}/${user_id}/${splitLink[6]}${(loggedUserId && "?userInitiated=true") || "" }`, '_blank');
    }
  };

  const removeHTMLTAggs = (str) => {
    if (str === null || str === "") return false;
    else str = str.toString();
    return str.replace(/<[^>]*>/g, "");
  };

  const getPopoverOfItems = useCallback(
    ({ item, comment_count, field_id, delay }) => {
      const requiredLength = field_id === "full_name" ? 1 : 0;
      let data = item[0][field_id];
      const result = data?.length > 23 ? data?.slice(0, 22) : data;
      return (
        <>
          {field_id === "full_name" && (
            <>
              {result}{" "}
              {data?.length > 23 && (
                <PopoverComponent
                  triggerWhen={["hover", "focus"]}
                  delay={delay}
                  selectedData={currentUserRole}
                  trigger={
                    field_id === "full_name" ? (
                      <span className="cursor-pointer-more-text-1">
                        {`....`}
                      </span>
                    ) : (
                      <button className="text-btn">
                        <Image imageSrc={Comment_icon} className="comments" />
                        <span className="comments-len popover-btn">{comment_count}</span>
                      </button>
                    )
                  }
                  fullBodyPresent={true}
                  children={
                    <>
                      <div className="option_list shadow-sm rounded-0 border-0 px-1 mb-2 mx-0 bg-white ">
                        <button className="option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey">
                          {data ? removeHTMLTAggs(data) : " "}
                        </button>
                      </div>
                    </>
                  }
                />
              )}
            </>
          )}
          {item?.length > requiredLength && (
            <PopoverComponent
              triggerWhen={["hover", "focus"]}
              delay={delay}
              selectedData={currentUserRole}
              trigger={
                field_id === "full_name" ? (
                  <span className="cursor-pointer more-text">
                    {", "} {`+${item.length - 1}more`}
                  </span>
                ) : (
                  <button className="text-btn">
                    <Image imageSrc={Comment_icon} className="comments" />
                    <span className="comments-len popover-btn">{comment_count}</span>
                  </button>
                
                )
              }
              fullBodyPresent={true}
              children={
                <>
                  <div className="bg-white shadow-sm max-w-150px p-2 d-flex flex-column">
                    {/**
                     * The following code displays the names of the applicants in the
                     * dashboard if case there are more than one user. 
                     */}
                    {item.map((ele, i) => {
                      if( i > 0 && field_id === "full_name") {
                        return <button className="bg-white fs-12px border-0 shadow-none p-2 bg-hover-grey bg-active-grey" key={i}>
                        {ele?.[field_id]
                          ? removeHTMLTAggs(ele?.[field_id])
                          : " "}
                      </button>
                      }
                    })}
                    {item.map((ele, i) =>
                      field_id === "full_name" ? null : field_id === "body" &&
                        i >= 1 ? null : (
                        <>
                          <button className="comments_data px-0 pt-1 bg-hover-grey cursor-pointer">
                            <div className="d-flex align-items-center justify-content-between">
                              <p className="comments_dataItems mb-0" key={i}>
                                {ele?.created_by}
                              </p>
                              <p className="comments_dataItems mb-0">
                                {ele?.created_at
                                  ? new Date(
                                      ele?.created_at
                                    ).toLocaleDateString()
                                  : " "}
                              </p>
                            </div>
                            <p className="comments_data word-break-all max-w-150px mb-0 bg-hover-grey cursor-pointer" onClick={() => handleRoute(item[0]?.workflow_id)}>                              
                              {getFormattedComment(ele?.body)}
                            </p>
                          </button>
                        </>
                      )
                    )}
                    {item.length > 1 && field_id === "body" && (
                      <>
                        <span
                          className="comment text-theme fs-12px"
                          onClick={() => handleRoute(item[0]?.workflow_id)}
                        >
                          View all comments
                        </span>
                      </>
                    )}
                  </div>
                </>
              }
            />
          )}
        </>
      );
    },
    [fields]
  );

  const handleCheckboxClick = (id) => {
    setCheckboxList({ key: id, value: !checkboxList?.[id] });
  };

  const handleSortOptionClick = (data, type) => {
    let selectedSortOptions = structuredClone(selectedTableSortOptions);
    if(selectedSortOptions?.[type]?.[data]) {
      dispatch(setSelectedTableSortOptions({}));
    } else {
      let obj = {
        [type] : {
          [data] : true
        }
      }
      clearAllSortArray?.(true)
      dispatch(setSelectedTableSortOptions(obj));
    }    
  }

  const handleFilterCheckBoxList = (data, type, dataType) => {
    let selectedFilterData = structuredClone(selectedFilterCheckboxList);
    if (filterDropdownList?.hasOwnProperty(type)) {
      if (!selectedFilterData?.hasOwnProperty(type) || selectedFilterData[type] == undefined) {
        selectedFilterData[type] = {};
        selectedFilterData[type][data] = true;
      }else{
          if(dataType=='date'){
            if(Object.keys(selectedFilterData[type]).length === 0){
              selectedFilterData[type][data] = true;
            }else if(selectedFilterData[type].hasOwnProperty(data)){
              selectedFilterData[type] = {}
            }else{
              selectedFilterData[type] = {}
              selectedFilterData[type][data] = true;
            }
          }else{
            if(selectedFilterData?.hasOwnProperty(type)){
              selectedFilterData[type][data] = !selectedFilterData[type][data]
            }
          }
      }
    }
    let list = {};
    list.value = selectedFilterData;
    list.type = type;
    dispatch(setFilterCheckboxList(list));
  };

  const handleBulkFilterCheckBoxList = (dataArray, type, dataType, checkAll = true) => {
  let selectedFilterData = structuredClone(selectedFilterCheckboxList);

  if (!selectedFilterData.hasOwnProperty(type) || selectedFilterData[type] == undefined) {
    selectedFilterData[type] = {};
  }

  dataArray.forEach((data) => {
    if (checkAll) {
      selectedFilterData[type][data] = true;
    } else {
      delete selectedFilterData[type][data];
    }
  });

  let list = {};
  list.value = selectedFilterData;
  list.type = type;
  dispatch(setFilterCheckboxList(list));
};


  const getCheckList = () => {
    const _fields = checkboxFields.filter((item) => item.name);
    return (
      <div className="option_list shadow border-0 rounded-0 bg-white theme-scrollbar-hover min-w-100px p-0">
        {_fields.map((item, i) => (
          <button
            key={i}
            onClick={() => handleCheckboxClick(item?.id)}
            className={`d-flex justify-content-between text-btn p-2 bg-hover-grey bg-active-grey fs-14px `}
          >
            <label className="cursor-pointer">{item?.name}</label>
            <Form.Check
              key={i}
              type={"checkbox"}
              id={item?.id}
              className="checkbox mx-2"
              checked={checkboxList[item?.id]}
            />
          </button>
        ))}
        {/* <button className="option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey">Send reminder</button>
        <button className="option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey">Schedule a video call</button>
        <button className="option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey">Delete</button> */}
        
        <hr className="m-0" />
        <button
          className="btn bg-white rounded-0 w-100  bg-hover-grey bg-active-grey border-0 "
          onClick={handleCheckboxClear}
        >
          <label className="cursor-pointer text-label fs-14px">
            Clear column values
          </label>
        </button>
      </div>
    );
  };

  const getFilerCheckList = (id,dataType, filterType,name) => {
    let current_filter = filterDropdownList?.[id]?.value;
    return (
      <FilterOptions 
        current_filter={current_filter}
        id={id}
        name={name}
        handleFilterCheckBoxList={handleFilterCheckBoxList}
        handleBulkFilterCheckBoxList={handleBulkFilterCheckBoxList}
        dataType={dataType}
        filterType={filterType}
        handleClearSort={handleClearSort}
        handleClearFilter={handleClearFilter}
        handleApplyFilter={handleApplyFilter}
        selectedFilterCheckboxList={selectedFilterCheckboxList}
      />
    )
  }

  const getSortList = (id, dataType, filterType) => {
    let current_filter = filterDropdownList?.[id]?.value;
    return (
      <div className=".option_list bg-white shadow overflow-y-auto theme-scrollbar max-h-400px pb-0">
        {current_filter?.map((item, i) => (
          <button
            key={i}
            onClick={() =>
              handleSortOptionClick(item?.id, id, dataType, filterType)
            }
            className={`btn border-0 bg-white d-flex justify-content-between align-items-center w-100 py-2  bg-hover-grey bg-active-grey`}
          >
            <label className="cursor-pointer pe-2 fs-14px">{item?.lable}</label>
            <Form.Check
              key={i}
              type={"checkbox"}
              id={item?.id}
              className="checkbox d-flex align-items-center ms-3 me-0"
              checked={selectedTableSortOptions?.[id]?.[item?.id] || false}
            />
          </button>
        ))}
        <div className="d-flex justify-content-evenly align-items-center position-sticky bottom-0 bg-white border-top">
          {
            <button
              className="btn bg-white rounded-0 w-100  bg-hover-grey bg-active-grey border-0 "
              onClick={() => {
                handleClearSort()
              }}
            >
              <label className="cursor-pointer text-label fs-14px ">
                Clear all
              </label>
            </button>
          }
        </div>
      </div>
    );
  };

  const handleMasterCheckboxChange = () => {
    let workflowIds = users.map((user) => {
        return user.workflow_id;
      })
      dispatch(setVerificationWorkflows(workflowIds));      
      setSelectAll(!selectAll);
      setUsers(users.map((user) =>  ({...user, checked: !selectAll})))
      dispatch(setSelectedData({key: 'verifyBtn', value: !selectAll }))
  };

  // handling each user checkbox change and the action
  const handleUserCheckboxChange = ({userId, event}) => {

    const isChecked = event.target.checked;

    if(isChecked){
      dispatch(setVerificationWorkflows([userId]));
    }
    if(!isChecked){
      dispatch(clearVerificationWorkflows(userId))
    }

    // Update only the specific user's checked status, leave other users' checkboxes unchanged
    const updatedUsers = newUserDetails.map((user) => {
      if (user?.workflow_id === userId) {
        return { ...user, checked: isChecked };
      } else {
        return user;
      }
    });
    setUsers(updatedUsers);
  }
  newUserDetails = [...users]


  useEffect(() => {
    const allChecked = newUserDetails.every((user) => user.checked);
    if(allChecked){
      setSelectAll(allChecked)
    }else{
      setSelectAll(false);
    }
  }, [newUserDetails])

  useEffect(() => {
    const allChecked = newUserDetails.some((user) => user.checked);
    if(!selectAll && !allChecked){
      dispatch(clearVerificationWorkflows())
    }
  }, [selectAll])

  const setRow = (value) => {

    // setListings(value);
    dispatch(setNumberOfRecords(value))
    dispatch(setRowPerPage(value));
    dispatch(setRowsChange(true));
    // handlePageClick("first", value);
  };


  return (
    <>
      {sendReminderToast?.status && (
              <Toast
                  type={sendReminderToast?.type}
                  message={sendReminderToast?.message}
                  autoClose={3000}
              />
          )}
      {copiedToClipBoardSuccessFully && (
        <Toast
          // onClose = {()=>dispatch(resetAddedNewComment())}
          message="Copied to clipboard successfully!"
          type="success"
          autoClose={3000}
        />
      )}
      {userDetails?.length > 0 ? (
      <>
        <div className="table-responsive  dashboard-detail-container-height theme-scrollbar-hover overflow-auto scroll-smooth">
          <Table hover bsPrefix="dashboard-table table table-bordered mb-0">
            <thead>
              <tr className="bg-white position-sticky border-sm-bottom border-0 outline-theme z-index-5" style={{top:1}}>
                {fields.map((ele, i, arr) => (
                  <th
                    className={`dashboard-data max-w-300px text-start py-0 px-0  ${
                      ele.name === "Comments" ? "text-center" : ""
                    }
                     ${ele?.custom_style} ${
                      i === 0 ? "min-w-200px border-end " : "border-end"
                    } ${
                      arr.length - 2 === i
                        ? "" : ""
                    } ${
                      arr.length - 1 === i
                        ? "min-w-50px text-center outline-transparent border-start-0 border-end "
                        : ""
                    }`}
                    key={i}
                  >
                    {ele?.name ? (
                      ele?.filter_required ? (
                        <>
                          <span className="d-flex align-items-center text-nowrap justify-content-around">
                            {ele.name}
                            {/* <span>
                              {selectedFilterCheckboxList[ele?.id] &&
                                Object?.values(
                                  selectedFilterCheckboxList[ele?.id]
                                ).some((value) => value === true) && (
                                  <PopoverComponent
                                    trigger={
                                      <span className="cursor-pointer">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="13"
                                          height="13"
                                          fill="currentColor"
                                          class="bi bi-funnel-fill"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5z" />
                                        </svg>
                                      </span>
                                    }
                                    children={
                                      <button className=" btn bg-white fs-13px p-2 shadow border-0 rounded-0 bg-active-grey ">
                                        <p
                                          className="mb-0 mt-1"
                                          onClick={() =>
                                            handleClearFilter(ele.id)
                                          }
                                        >
                                          Clear filters
                                        </p>
                                      </button>
                                    }
                                    fullBodyPresent={true}
                                  />
                                )}
                            </span> */}
                            <span className="">
                            <Filter 
                              ele={ele}
                              getSortList={getSortList}
                              getFilerCheckList={getFilerCheckList}
                              name={ele?.id}
                              selectedFilterCheckboxList={selectedFilterCheckboxList}
                            />
                            </span>
                          </span>
                        </>
                      ) : (
                        <>
                          {i === 0 &&
                            dashboardConfig?.header_structure
                              ?.bulk_bank_verification && (
                              <span className="checkbox-verify">
                                <input
                                  type="checkbox"
                                  checked={selectAll}
                                  onChange={handleMasterCheckboxChange}
                                />{" "}
                              </span>
                            )}
                            <div 
                            // className={ele.name === 'Status' || ele.name === 'Internal POC' ?( i === 0 ? " " : '  '):( i === 0 ? "h-100 " : '')}
                              className={`justify-content-between h-100 d-flex align-items-center min-h-40px pt-1 border-sm-table ${
                                ele.name === "Comments" ? "text-center" : ""
                              }
                               ${
                                i === 0 ? " ps-2" : "px-2"
                              } ${
                                ele.name === 'Status' || ele.name === 'Internal POC'
                                  ? "border-end-0" : ""
                              } ${
                                arr.length - 1 === i
                                  ? "min-w-50px text-center outline-transparent " : ""
                              } ${
                                arr.length - 2 === i
                                  ? "" : ""
                              }`}
                            >
                            {ele.name}  {}
                          {/* {ele.name === "Status" ? (
                      <svg  xmlns="http://www.w3.org/2000/svg" width="9.8" height="6.043" viewBox="0 0 9.8 6.043">
                        <path id="expand_more_FILL0_wght400_GRAD0_opsz24_1_" data-name="expand_more_FILL0_wght400_GRAD0_opsz24 (1)" d="M244.9-634.957l-4.9-4.9L241.143-641l3.757,3.756L248.656-641l1.143,1.143Z" transform="translate(-240 641)"/>
                      </svg>
                      ) : ''}
                      {ele.name === "Internal POC" ? (
                        <svg  xmlns="http://www.w3.org/2000/svg" width="9.8" height="6.043" viewBox="0 0 9.8 6.043">
                          <path id="expand_more_FILL0_wght400_GRAD0_opsz24_1_" data-name="expand_more_FILL0_wght400_GRAD0_opsz24 (1)" d="M244.9-634.957l-4.9-4.9L241.143-641l3.757,3.756L248.656-641l1.143,1.143Z" transform="translate(-240 641)"/>
                        </svg>
                        ) : ''} */}
                            </div>
                          {/* add border here */}
                        </>
                      )
                    ) : (
                      <PopoverComponent
                        trigger={
                          <div className="h-100 border-start border-end d-flex align-items-center justify-content-center border-sm-table">
                            <button className="ps-2 add_column_button">
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: addColumnIcon,
                                }}
                              ></span>
                            </button>
                          </div>
                        }
                        children={<>{getCheckList()}</>}
                        fullBodyPresent={true}
                      />
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {userDetails?.length > 0 ? (
                userDetails.map((item, i) => (


                  <tr key={i} className=".border-bottom mb-2">
                    {fields.map((ele, i, arr) => (
                      <td
                        key={i}
                        className={`dashboard-data p-0 max-w-300px text-start  ${
                          ele.name === "Comments" ? "text-center" : ""
                        } 
                        ${ele?.name === "Application ref id"  ? "text-hover-primary cursor-pointer" : ""}
                        
                        ${ele?.custom_style}
                         ${
                          i === 0
                            ? "min-w-200px .border-bottom outline-transparent"
                            : arr.length - 1 === i? "" : "px-3"
                        }
                          ${ele?.name === "Name of the applicant" ? "text-hover-primary" : ""}

                         ${
                          arr.length - 1 === i 
                            ? "min-w-50px text-center outline-transparent px-0 border-bottom border-end"
                            : (i != 0 ? "border-bottom border-end" : "border-bottom")
                        } ${
                          arr.length - 2 === i 
                            ? "" : i
                        } 
                        ${i===0 ? 'border ps-3':''}
                        `}
                        
                      >
                       
                        <TableBody
                          ele={ele}
                          item={item}
                          index={i}
                          handleRoute={handleRoute}
                          handleOptionsClick={handleOptionsClick}
                          getPopoverOfItems={getPopoverOfItems}
                          selectedData={{
                            ...currentUserRole,
                            internalPocUsers,
                            all_users
                          }}
                          setCopiedToClipBoardSuccessFully={
                            setCopiedToClipBoardSuccessFully
                          }
                          copiedToClipBoardSuccessFully={
                            copiedToClipBoardSuccessFully
                          }
                          dashboardConfig={dashboardConfig}
                          userDetails={newUserDetails}
                          toggleUserSelect={handleUserCheckboxChange}
                          selectAll={selectAll}
                        />
                         {/* {ele.name === "Internal POC" ? (
                          <svg className="mx-3" xmlns="http://www.w3.org/2000/svg" width="9.8" height="6.043" viewBox="0 0 9.8 6.043">
                            <path id="expand_more_FILL0_wght400_GRAD0_opsz24_1_" data-name="expand_more_FILL0_wght400_GRAD0_opsz24 (1)" d="M244.9-634.957l-4.9-4.9L241.143-641l3.757,3.756L248.656-641l1.143,1.143Z" transform="translate(-240 641)"/>
                          </svg>
                          ):''} */}
                      </td>
                    ))}
                  </tr>
                  
                ))
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  className="text-center not-found-text"

                  
                >
                  <img
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "100%",
                    }}
                    src={NoDataFoundPic}
                    alt="No data found"
                  />
                </div>
              )}

            </tbody>
          </Table>



        </div>
          <div className="d-flex align-items-center justify-content-between">
          <div className="align-items-center bg-theme-grey-3 d-flex fs-14px justify-content-center p-2">
               Total records: {total_records}
             </div>

            <div className="bg-theme-grey-3 p-0">
              <Pagination className="mb-0 d-flex align-items-center justify-content-center justify-content-lg-start">
                {/* <Dropdown show={show}>
            <Dropdown.Toggle onMouseOver={()=>{setShow(true)}} className="bg-white text-black border-0 py-0" id="dropdown-basic">
                <p className="m-0 fs-14px px-2 py-1 mt-1 bg-hover-grey rounded-2 pe-1">
                    {(pagination?.pageNum - 1) * listings + 1} -{''}
                    {total_count > listings ? `${pagination?.pageNum * listings} of ${ pagination?.count * listings}` 
                    : `${pagination?.pageNum} of ${pagination?.count}`}
                 </p>
            </Dropdown.Toggle>
            <Dropdown.Menu onMouseLeave={()=>{setShow(false)}} className="border-0 rounded-0 shadow min-w-100px" >
                <Dropdown.Item className="bg-active-grey fs-14px" onClick={() => setRow(10)}>10 per page</Dropdown.Item>
                <Dropdown.Item className="bg-active-grey fs-14px" onClick={() => setRow(15)}>15 per page</Dropdown.Item>
                <Dropdown.Item className="bg-active-grey fs-14px" onClick={() => setRow(20)}>20 per page</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}


                <div>
                  <p className="mb-0 fs-14px px-2 py-1 rounded-2 text-center mt-1 d-lg-none">
                    {(pagination?.pageNum - 1) * numberOfRecords + 1} - {''}
                    {total_count > numberOfRecords
                      ? `${pagination?.pageNum * numberOfRecords > total_count ? total_count : pagination?.pageNum * numberOfRecords
                      } of ${total_count}`
                      : `${total_count} of ${total_count}`}
                  </p>
                </div>

                <div className="d-flex align-items-center mx-2">
                  <Pagination.First
                    className={`btn-padding-reset ${pagination?.pageNum > 1 ? '' : 'pagination-disabled'
                      }`}
                  >
                    <button
                      onClick={() => handlePageClick('first')}
                      disabled={pagination?.pageNum > 1 ? 0 : 1}
                      className={`p-0 fs-18px h-30px w-30px rounded-circle  d-flex align-items-center justify-content-center me-1 border-0 btn bg-active-grey ${pagination.pageNum > 1
                          ? 'bg-hover-grey cursor-pointer'
                          : ''
                        }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="6"
                        height="12"
                        viewBox="0 0 6 12"
                      >
                        <path
                          id="Path_54090"
                          data-name="Path 54090"
                          d="M5.181,5.85a.727.727,0,0,1-.513-.21L.213,1.227A.714.714,0,0,1,.213.21a.731.731,0,0,1,1.026,0l3.942,3.9L9.123.211a.731.731,0,0,1,1.026,0,.713.713,0,0,1,0,1.016L5.694,5.639A.727.727,0,0,1,5.181,5.85Z"
                          transform="translate(5.85) rotate(90)"
                          fill={`${pagination?.pageNum > 1
                              ? '#29323C'
                              : '#6c757d'
                            }`}
                        />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="6"
                        height="12"
                        viewBox="0 0 6 12"
                      >
                        <path
                          id="Path_54090"
                          data-name="Path 54090"
                          d="M5.181,5.85a.727.727,0,0,1-.513-.21L.213,1.227A.714.714,0,0,1,.213.21a.731.731,0,0,1,1.026,0l3.942,3.9L9.123.211a.731.731,0,0,1,1.026,0,.713.713,0,0,1,0,1.016L5.694,5.639A.727.727,0,0,1,5.181,5.85Z"
                          transform="translate(5.85) rotate(90)"
                          fill={`${pagination?.pageNum > 1
                              ? '#29323C'
                              : '#6c757d'
                            }`}
                        />
                      </svg>
                    </button>
                  </Pagination.First>
                  <Pagination.Prev
                    className={`btn-padding-reset ${pagination?.pageNum > 1 ? '' : 'pagination-disabled'
                      }`}
                  >
                    <button
                      disabled={pagination?.pageNum > 1 ? 0 : 1}
                      className={`p-0 fs-18px h-30px w-30px rounded-circle  d-flex align-items-center justify-content-center me-1 border-0 btn bg-active-grey ${pagination.pageNum > 1
                          ? 'bg-hover-grey cursor-pointer'
                          : ''
                        }`}
                      onClick={() => handlePageClick('prev')}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="6"
                        height="12"
                        viewBox="0 0 6 12"
                      >
                        <path
                          id="Path_54090"
                          data-name="Path 54090"
                          d="M5.181,5.85a.727.727,0,0,1-.513-.21L.213,1.227A.714.714,0,0,1,.213.21a.731.731,0,0,1,1.026,0l3.942,3.9L9.123.211a.731.731,0,0,1,1.026,0,.713.713,0,0,1,0,1.016L5.694,5.639A.727.727,0,0,1,5.181,5.85Z"
                          transform="translate(5.85) rotate(90)"
                          fill={`${pagination?.pageNum > 1
                              ? '#29323C'
                              : '#6c757d'
                            }`}
                        />
                      </svg>
                    </button>
                    <Pagination.Item></Pagination.Item>
                  </Pagination.Prev>
                  <div className="position-relative d-none d-lg-block">
                    <p className="mb-0 fs-14px py-1 rounded-2 pe-1 text-center mt-1">
                      {(pagination?.pageNum - 1) * numberOfRecords + 1} - {''}
                      {total_count > numberOfRecords
                        ? `${pagination?.pageNum * numberOfRecords > total_count ? total_count : pagination?.pageNum * numberOfRecords
                        } of ${total_count}`
                        : `${total_count} of ${total_count}`}
                      {/* <div className="border-0 rounded-0 shadow-1 min-w-100px position-absolute bg-white z-index-6 py-2 lh-2 d-none hover-dropdown-menu start-0">
                          <Dropdown.Item
                              className={`bg-active-grey fs-14px py-1 ${
                                numberOfRecords === 5 ? 'bg-light' : ''
                              }`}
                              onClick={() => setRow(5)}
                          >
                              5 per page
                          </Dropdown.Item>
                          <Dropdown.Item
                              className={`bg-active-grey fs-14px py-1 ${
                                numberOfRecords === 10 ? 'bg-light' : ''
                              }`}
                              onClick={() => setRow(10)}
                          >
                              10 per page
                          </Dropdown.Item>
                          <Dropdown.Item
                              className={`bg-active-grey fs-14px py-1 ${
                                numberOfRecords === 15 ? 'bg-light' : ''
                              }`}
                              onClick={() => setRow(15)}
                          >
                              15 per page
                          </Dropdown.Item>
                          <Dropdown.Item
                              className={`bg-active-grey fs-14px py-1 ${
                                numberOfRecords === 20 ? 'bg-light' : ''
                              }`}
                              onClick={() => setRow(20)}
                          >
                              20 per page
                          </Dropdown.Item>
                      </div> */}
                    </p>
                  </div>                  <Pagination.Next
                    className={`btn-padding-reset ${pagination?.pageNum === pagination?.count
                        ? 'pagination-disabled'
                        : ''
                      }`}
                  >
                    <button
                      disabled={pagination?.pageNum === pagination?.count}
                      className={`p-0 fs-18px h-30px w-30px rounded-circle  d-flex align-items-center justify-content-center me-1 border-0 btn bg-active-grey ${pagination?.pageNum === pagination?.count
                          ? ''
                          : 'bg-hover-grey cursor-pointer'
                        }`}
                      onClick={() => handlePageClick('next')}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="6"
                        height="12"
                        viewBox="0 0 6 12"
                      >
                        <path
                          id="Path_53944"
                          data-name="Path 53944"
                          d="M5.181,0a.727.727,0,0,0-.513.21L.213,4.623a.714.714,0,0,0,0,1.016.731.731,0,0,0,1.026,0l3.942-3.9,3.942,3.9a.731.731,0,0,0,1.026,0,.713.713,0,0,0,0-1.016L5.694.21A.727.727,0,0,0,5.181,0Z"
                          transform="translate(5.85) rotate(90)"
                          fill={`${pagination?.pageNum === pagination?.count
                              ? '#6c757d'
                              : '#29323C'
                            }`}
                        />
                      </svg>
                    </button>
                  </Pagination.Next>
                  <Pagination.Last
                    className={`btn-padding-reset ${pagination?.pageNum === pagination?.count
                        ? 'pagination-disabled'
                        : ''
                      }`}
                  >
                    <button onClick={() => handlePageClick('last')}
                      disabled={pagination?.pageNum === pagination?.count}
                      className={`p-0 fs-18px h-30px w-30px rounded-circle  d-flex align-items-center justify-content-center me-1 border-0 btn bg-active-grey ${pagination?.pageNum === pagination?.count
                          ? ''
                          : 'bg-hover-grey cursor-pointer'
                        }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="6"
                        height="12"
                        viewBox="0 0 6 12"
                      >
                        <path
                          id="Path_53944"
                          data-name="Path 53944"
                          d="M5.181,0a.727.727,0,0,0-.513.21L.213,4.623a.714.714,0,0,0,0,1.016.731.731,0,0,0,1.026,0l3.942-3.9,3.942,3.9a.731.731,0,0,0,1.026,0,.713.713,0,0,0,0-1.016L5.694.21A.727.727,0,0,0,5.181,0Z"
                          transform="translate(5.85) rotate(90)"
                          fill={`${pagination?.pageNum === pagination?.count
                              ? '#6c757d'
                              : '#29323C'
                            }`}
                        />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="6"
                        height="12"
                        viewBox="0 0 6 12"
                      >
                        <path
                          id="Path_53944"
                          data-name="Path 53944"
                          d="M5.181,0a.727.727,0,0,0-.513.21L.213,4.623a.714.714,0,0,0,0,1.016.731.731,0,0,0,1.026,0l3.942-3.9,3.942,3.9a.731.731,0,0,0,1.026,0,.713.713,0,0,0,0-1.016L5.694.21A.727.727,0,0,0,5.181,0Z"
                          transform="translate(5.85) rotate(90)"
                          fill={`${pagination?.pageNum === pagination?.count
                              ? '#6c757d'
                              : '#29323C'
                            }`}
                        />
                      </svg>
                    </button>
                  </Pagination.Last>
                </div>
              </Pagination>
            </div>
          </div>
              </>
      ) : (
        <>
          <div className="text-center not-found-text flex-column dashboard-table-container-height">
            <img
              style={{
                objectFit: "contain",
                width: "30vw",
                height: "40vh",
              }}
              src={NoDataFoundPic}
              alt="No data found"
            />

            {!showClearFilter && (
              <Button
                className="bg-white text-theme border-theme fw-semibold text-center mt-3"
                onClick={clearAllFilter}
              >
                <p className="mt-1 mb-0">Clear all filters</p>
              </Button>
            )}
          </div>
        </>
      )}
    </>
  );
}

export default TableComponent;
